// extracted by css-extract-rspack-plugin
export default {"root":"PROl_nFISwK14G3y","head":"qK6Wou4gksIXSWYf","tail":"CYGIYHUvDwcVIBht"};